import { render } from "./CreateContent.vue?vue&type=template&id=d57313ac"
import script from "./CreateContent.vue?vue&type=script&lang=js"
export * from "./CreateContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__